import SvgIcon from "./IconChevronDownLine.svg?react";

export const IconChevronDownLine = SvgIcon;
